var render = function render(){var _vm=this,_c=_vm._self._c;return _c('confirm-modal',{ref:"confirmModal",attrs:{"name":"confirm-canvas-action","callback":_vm.actionCallback,"confirm-message":_vm.actionMessage}})
}
var staticRenderFns = []

export { render, staticRenderFns }